/// <reference path="../generated/MitgliedschaftAnlagePersonResponseApi.d.ts"/>
import { ModelAdapter } from './ModelAdapter';
import { PartnerViewModel } from '../view/Partner';
import { ChildModel } from '../view/Child';
import { PartnerApi } from '../generated/MitgliedschaftPartnerApi';
import { KindApi } from '../generated/MitgliedschaftKindApi';
import { TimeService } from '../../services/TimeService';
import { AppUtils } from './../../utils/index';

/**
 * Converts insurance view models to api models and vice versa.
 */
export class MglAdapter extends ModelAdapter {

	/**
	 * Converts an api model to PartnerViewModel.
	 */
	public static getPartnerViewModel(partnerApiResponse: AnlagePersonResponseApi): PartnerViewModel {
		const partner = new PartnerViewModel();
		if (partnerApiResponse) {
			partner.Mitgliedsnummer = partnerApiResponse.Mitgliedsnummer;
			partner.PersonalData.AnredeKennzeichen = partnerApiResponse.Anrede;
			partner.PersonalData.Titel = partnerApiResponse.Titel;
			partner.PersonalData.Vorname = partnerApiResponse.Vorname;
			partner.PersonalData.Nachname = partnerApiResponse.Nachname;
			partner.PersonalData.Geburtsdatum = partnerApiResponse.Geburtsdatum;
			partner.PersonalData.Email = partnerApiResponse.Email;
			if (partnerApiResponse.Telefon) {
				partner.PersonalData.TelefonVorwahl = partnerApiResponse.Telefon.Prefix;
				partner.PersonalData.TelefonNummer = partnerApiResponse.Telefon.Suffix;
			}
		}
		return partner;
	}

	/**
	 * Converts a view model to an api model.
	 */
	public static getPartnerApi(partnerView: PartnerViewModel): PartnerApi {
		const partner = new PartnerApi();
		partner.Anrede = partnerView.PersonalData.AnredeKennzeichen;
		partner.Titel = partnerView.PersonalData.Titel;
		partner.Vorname = partnerView.PersonalData.Vorname;
		partner.Nachname = partnerView.PersonalData.Nachname;
		partner.Geburtsdatum = AppUtils.Format.viewDateToIsoDate(partnerView.PersonalData.Geburtsdatum);
		partner.Email = partnerView.PersonalData.Email;
		partner.Telefon = ModelAdapter.getPhoneApi(partnerView.PersonalData.TelefonVorwahl, partnerView.PersonalData.TelefonNummer);
		return partner;
	}

	/**
	 * Converts a view model to an api model.
	 */
	public static getKindApi(child: ChildModel): KindApi {
		const kind = new KindApi();
		const kindId = child.Id.split("_")[1];
		kind.Id = Number(kindId);
		kind.Anrede = child.PersonalData.AnredeKennzeichen;
		kind.Titel = child.PersonalData.Titel;
		kind.Anschrift = ModelAdapter.getAddressApi(child.Adresse);
		kind.Email = child.PersonalData.Email;
		kind.Geburtsdatum = AppUtils.Format.viewDateToIsoDate(child.PersonalData.Geburtsdatum);
		kind.Nachname = child.PersonalData.Nachname;
		kind.Telefon = ModelAdapter.getPhoneApi(child.PersonalData.TelefonVorwahl, child.PersonalData.TelefonNummer);
		kind.Vorname = child.PersonalData.Vorname;
		kind.HatAbweichendeAnschrift = child.HatAbweichendeAdresse;
		return kind;
	}

	public static getStartOfMembershipDate(beginFieldVal: string): string {
		const dateFormat = "DD.MM.YYYY";
		let beginDate: string;
		let startDateIso = AppUtils.Format.viewDateToIsoDate(moment(new Date()).format(dateFormat));

		if (beginFieldVal !== "") {
			const currentDay = moment(new Date()).date();
			const split = beginFieldVal.split(".");
			if (split.length === 3) {
				beginDate = moment(`${currentDay}.${split[1]}.${split[2]}`, dateFormat).format(dateFormat);
			} else {
				beginDate = moment(`${currentDay}.${split[0]}.${split[1]}`, dateFormat).format(dateFormat);
			}

			startDateIso = AppUtils.Format.viewDateToIsoDate(beginDate);
		}

		return startDateIso;
	}

	public static getKinderGeburtstagsArray(geburtstage: Array<string>, addChild: boolean, addJuv: boolean, existingChilds = 0, exsitingJuvs = 0): Array<string> {
		const timeService = new TimeService();
		let missingChild = addChild;
		let missingJuv = addJuv;

		geburtstage.forEach(geburtstag => {
			const age = timeService.getCurrentAgeInMonths(moment(geburtstag));
			//215 = (17 * 12) + 11
			if (age > 215) {
				missingJuv = false;
			} else {
				missingChild = false;
			}
		});

		if (missingChild) {
			geburtstage.push(timeService.getDefaultBirthday(16));
		}
		if (missingJuv) {
			geburtstage.push(timeService.getDefaultBirthday(19));
		}

		for (let i = exsitingJuvs; i > 0; i--) {
			geburtstage.push(timeService.getDefaultBirthday(19));
		}

		for (let i = existingChilds; i > 0; i--) {
			geburtstage.push(timeService.getDefaultBirthday(16));
		}

		return geburtstage;
	}

	public static getKinderGeburtstagsArrayV2(childs: Array<ChildModel>, requiredChilds = 0, requiredJuvs = 0, existingChilds = 0, exsitingJuvs = 0): Array<string> {
		const result = [];
		const timeService = new TimeService();

		childs.forEach(child => {
			if (child.PersonalData.Geburtsdatum) {
				result.push(child.PersonalData.Geburtsdatum);
			} else if (child.IsJuv && requiredJuvs > 0) {
				result.push(timeService.getDefaultBirthday(19));
				requiredJuvs--;
			} else if (requiredChilds > 0) {
				result.push(timeService.getDefaultBirthday(16));
				requiredChilds--;
			}
		});

		for (let i = requiredJuvs; i > 0; i--) {
			result.push(timeService.getDefaultBirthday(19));
		}

		for (let i = requiredChilds; i > 0; i--) {
			result.push(timeService.getDefaultBirthday(16));
		}

		for (let i = exsitingJuvs; i > 0; i--) {
			result.push(timeService.getDefaultBirthday(19));
		}

		for (let i = existingChilds; i > 0; i--) {
			result.push(timeService.getDefaultBirthday(16));
		}

		return result;
	}

}
